import React, { forwardRef, useEffect, useMemo, useState } from 'react';

const coerceNumber = (v, fallback) => {
  if (v === '' || v === null || v === undefined) return fallback;
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

const InputRange = forwardRef(
  (
    {
      fieldName,
      value = '',
      min = 0,
      max = 10000,
      step = 1,
      disabled = false,
      errors = [],
      style = {},
      pk = null,
      showValue = true,
      showNumberInput = true,
      onChange = () => {},
    },
    ref
  ) => {
    const normalized = useMemo(() => {
      const minN = coerceNumber(min, 0);
      const maxN = coerceNumber(max, 100);
      const stepN = coerceNumber(step, 1);
      const valN = coerceNumber(value, value === '' ? minN : minN);
      return { minN, maxN, stepN, valN };
    }, [min, max, step, value]);

    const [inputValue, setInputValue] = useState(normalized.valN);

    useEffect(() => {
      setInputValue(normalized.valN);
    }, [normalized.valN]);

    const pct = useMemo(() => {
      const denom = normalized.maxN - normalized.minN;
      if (!Number.isFinite(denom) || denom <= 0) return 0;
      const raw = ((inputValue - normalized.minN) / denom) * 100;
      return Math.max(0, Math.min(100, raw));
    }, [inputValue, normalized.maxN, normalized.minN]);

    const localOnChange = (e) => {
      const next = coerceNumber(e.target.value, normalized.minN);
      setInputValue(next);
      onChange({ name: fieldName, type: 'change', value: next, label: String(next) });
    };

    const onBlur = (e) => {
      const next = coerceNumber(e.target.value, normalized.minN);
      onChange({ name: fieldName, type: 'blur', value: next, label: String(next) });
    };

    const localOnChangeNumber = (e) => {
      const raw = e.target.value;
      if (raw === '') {
        setInputValue(normalized.minN);
        onChange({ name: fieldName, type: 'change', value: normalized.minN, label: String(normalized.minN) });
        return;
      }
      const next = coerceNumber(raw, normalized.minN);
      setInputValue(next);
      onChange({ name: fieldName, type: 'change', value: next, label: String(next) });
    };

    const onBlurNumber = (e) => {
      const next = coerceNumber(e.target.value, normalized.minN);
      onChange({ name: fieldName, type: 'blur', value: next, label: String(next) });
    };

    return (
      <div className="input-range-slicer d-flex align-items-center gap-2">
        <input
          ref={ref}
          id={pk ? pk + '_' + fieldName : fieldName}
          name={fieldName}
          className={`form-range ${style.class || ''} ${errors.length > 0 ? 'is-invalid' : ''}`}
          type="range"
          min={normalized.minN}
          max={normalized.maxN}
          step={normalized.stepN}
          value={inputValue}
          style={{ '--slicer-pct': `${pct}%` }}
          disabled={disabled}
          onBlur={onBlur}
          onChange={localOnChange}
        />
        {showNumberInput ? (
          <input
            type="number"
            className={`form-control form-control-sm ${errors.length > 0 ? 'is-invalid' : ''}`}
            style={{ width: 96 }}
            min={normalized.minN}
            max={normalized.maxN}
            step={normalized.stepN}
            value={inputValue}
            disabled={disabled}
            onChange={localOnChangeNumber}
            onBlur={onBlurNumber}
          />
        ) : null}
        {showValue && !showNumberInput ? (
          <span className="badge bg-light text-dark border" style={{ minWidth: 48, textAlign: 'center' }}>
            {inputValue}
          </span>
        ) : null}
      </div>
    );
  }
);

export default InputRange;

